import type { PropsWithChildren } from "react"
import type { IPermissionBase } from "@/entities/permission/types.ts"
import { useCurrentUser } from "@/shared/hooks/use-current-user.ts"

interface IProps extends PropsWithChildren {
  allowedPermissions: IPermissionBase[]
}

export function WithPermissions({ children, allowedPermissions }: IProps) {
  const { permissions } = useCurrentUser()

  if (!permissions?.length) return null

  const hasPermission = allowedPermissions.some(p => permissions.includes(p))
  if (!hasPermission) return null

  return children
}
